// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.clientsHeader_gJzWw {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  gap: 0px;
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 20px;

  .headerInfo_qHO_o {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 2px 20px;

    @media (width<=933px) {
      flex-direction: column;
      gap: 0px;
      align-items: start;
    }

    @media (width<=768px) {
      justify-content: center;
      gap: 0px;
      flex-direction: column;
      align-items: center;
    }

    .additionalInfo_DE9P5 {
      padding: 10px 0;
      box-sizing: border-box;
      width: 100%;
      flex: 1 1;
      max-width: fit-content;

      @media (width<=933px) {
        padding: 0px 0 10px 0;
      }
    }
  }

  h2 {
    font-size: 26px;
    margin: 0px;
    color: var(--black-color);
  }

}

.infoClient_fcov5 {
  display: flex;
  color: var(--_6-color);
  gap: 10px;

  h3,
  p {
    margin: 0;
    color: var(--black-color);
  }

  h3 {
    font-weight: bold;
    font-size: 22px;
    color: var(--black-color);
  }

  p {
    font-weight: bold;
    color: var(--black-color);
  }
}

.arrowContainer_fQguU {
  height: 100%;
}

.iconContainer_oO7X4 {
  border: none;
  outline: none;
  border-radius: 6px;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  -ms-border-radius: 6px;
  -o-border-radius: 6px;
  cursor: pointer;
  border: 1px solid transparent;
  padding: 4px;
  display: flex;
  background-color: var(--_10A37F-background);
  color: var(--white-color);
  align-items: center;
  justify-content: center;
  height: fit-content;
  box-sizing: border-box;
  height: 25px;
  width: 25px;
}

.clientInfo_JnTtm {
  display: flex;
  flex-direction: column;
}

.contactInfo_ZfSQc,
.info_Mx2L_ {
  display: flex;
  gap: 10px;
  align-items: center;
}

.contactInfo_ZfSQc {
  flex-wrap: wrap;
}

.searchContainer_pfbU5 {
  display: flex;
  align-items: center;
  height: fit-content;
  gap: 20px;
  flex-wrap: wrap;

  @media (width<=768px) {
    justify-content: center;
  }

  .button_XQ4pw {
    text-decoration: underline;
    cursor: pointer;
    color: var(--_2-color);
    min-width: fit-content;
  }
}

.imgContainer_GAxaZ {
  display: flex;
  align-items: center;
  height: 100px;
  width: 200px;
  gap: 10px;

  img {
    height: 30px;
    width: 30px;
    border-radius: 50%;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    -ms-border-radius: 50%;
    -o-border-radius: 50%;
  }
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/ClientsHeader/ClientsHeader.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;EACtB,QAAQ;EACR,WAAW;EACX,sBAAsB;EACtB,mBAAmB;;EAEnB;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,aAAa;;IAEb;MACE,sBAAsB;MACtB,QAAQ;MACR,kBAAkB;IACpB;;IAEA;MACE,uBAAuB;MACvB,QAAQ;MACR,sBAAsB;MACtB,mBAAmB;IACrB;;IAEA;MACE,eAAe;MACf,sBAAsB;MACtB,WAAW;MACX,SAAO;MACP,sBAAsB;;MAEtB;QACE,qBAAqB;MACvB;IACF;EACF;;EAEA;IACE,eAAe;IACf,WAAW;IACX,yBAAyB;EAC3B;;AAEF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;;EAET;;IAEE,SAAS;IACT,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;EAC3B;AACF;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf,6BAA6B;EAC7B,YAAY;EACZ,aAAa;EACb,2CAA2C;EAC3C,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,eAAe;;EAEf;IACE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,eAAe;IACf,sBAAsB;IACtB,sBAAsB;EACxB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,SAAS;;EAET;IACE,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;EACvB;AACF","sourcesContent":[".clientsHeader {\n  display: flex;\n  justify-content: space-between;\n  flex-direction: column;\n  gap: 0px;\n  width: 100%;\n  box-sizing: border-box;\n  margin-bottom: 20px;\n\n  .headerInfo {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    gap: 2px 20px;\n\n    @media (width<=933px) {\n      flex-direction: column;\n      gap: 0px;\n      align-items: start;\n    }\n\n    @media (width<=768px) {\n      justify-content: center;\n      gap: 0px;\n      flex-direction: column;\n      align-items: center;\n    }\n\n    .additionalInfo {\n      padding: 10px 0;\n      box-sizing: border-box;\n      width: 100%;\n      flex: 1;\n      max-width: fit-content;\n\n      @media (width<=933px) {\n        padding: 0px 0 10px 0;\n      }\n    }\n  }\n\n  h2 {\n    font-size: 26px;\n    margin: 0px;\n    color: var(--black-color);\n  }\n\n}\n\n.infoClient {\n  display: flex;\n  color: var(--_6-color);\n  gap: 10px;\n\n  h3,\n  p {\n    margin: 0;\n    color: var(--black-color);\n  }\n\n  h3 {\n    font-weight: bold;\n    font-size: 22px;\n    color: var(--black-color);\n  }\n\n  p {\n    font-weight: bold;\n    color: var(--black-color);\n  }\n}\n\n.arrowContainer {\n  height: 100%;\n}\n\n.iconContainer {\n  border: none;\n  outline: none;\n  border-radius: 6px;\n  -webkit-border-radius: 6px;\n  -moz-border-radius: 6px;\n  -ms-border-radius: 6px;\n  -o-border-radius: 6px;\n  cursor: pointer;\n  border: 1px solid transparent;\n  padding: 4px;\n  display: flex;\n  background-color: var(--_10A37F-background);\n  color: var(--white-color);\n  align-items: center;\n  justify-content: center;\n  height: fit-content;\n  box-sizing: border-box;\n  height: 25px;\n  width: 25px;\n}\n\n.clientInfo {\n  display: flex;\n  flex-direction: column;\n}\n\n.contactInfo,\n.info {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n.contactInfo {\n  flex-wrap: wrap;\n}\n\n.searchContainer {\n  display: flex;\n  align-items: center;\n  height: fit-content;\n  gap: 20px;\n  flex-wrap: wrap;\n\n  @media (width<=768px) {\n    justify-content: center;\n  }\n\n  .button {\n    text-decoration: underline;\n    cursor: pointer;\n    color: var(--_2-color);\n    min-width: fit-content;\n  }\n}\n\n.imgContainer {\n  display: flex;\n  align-items: center;\n  height: 100px;\n  width: 200px;\n  gap: 10px;\n\n  img {\n    height: 30px;\n    width: 30px;\n    border-radius: 50%;\n    -webkit-border-radius: 50%;\n    -moz-border-radius: 50%;\n    -ms-border-radius: 50%;\n    -o-border-radius: 50%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"clientsHeader": `clientsHeader_gJzWw`,
	"headerInfo": `headerInfo_qHO_o`,
	"additionalInfo": `additionalInfo_DE9P5`,
	"infoClient": `infoClient_fcov5`,
	"arrowContainer": `arrowContainer_fQguU`,
	"iconContainer": `iconContainer_oO7X4`,
	"clientInfo": `clientInfo_JnTtm`,
	"contactInfo": `contactInfo_ZfSQc`,
	"info": `info_Mx2L_`,
	"searchContainer": `searchContainer_pfbU5`,
	"button": `button_XQ4pw`,
	"imgContainer": `imgContainer_GAxaZ`
};
export default ___CSS_LOADER_EXPORT___;
